import { render, staticRenderFns } from "./OrganizationalUnitPerson.vue?vue&type=template&id=65d9ed67"
import script from "./OrganizationalUnitPerson.vue?vue&type=script&lang=js"
export * from "./OrganizationalUnitPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports